
export default {
    name: 'SvgLocation',
    props: {
        color: {
            type: String,
            default: '#ffffff',
        },
    },
};
